"use client";

import { faCartShopping } from "@fortawesome/pro-solid-svg-icons";
import { useTranslations } from "next-intl";
import { Icon } from "@/components/ui/Icon";
import { Link } from "@/i18n/navigation";
import { useCart } from "./CartContext";

/**
 * Deliberately NOT gated on `viewOnly` (TRY-85 step 3, decided to keep it).
 * `viewOnly` is `!isLive || catalogOnly`, so it covers a store that traded and
 * was then unpublished — those carts are real, not stale. A cart can also be
 * adopted from another tab by CartContext's `storage` listener. Hiding the link
 * (or purging localStorage) would strand a real cart with no way to reach or
 * empty it, which is the mirror image of the dead end this issue is about.
 */
export function CartLink() {
	const t = useTranslations("shop");
	const { count } = useCart();

	return (
		<Link
			href="/cart"
			className="inline-flex h-9 items-center justify-center gap-2 rounded-lg border border-border px-2.5 text-sm font-medium transition hover:bg-surface-2"
			aria-label={t("cart")}
		>
			<Icon icon={faCartShopping} size={16} />
			<span className="hidden sm:inline">{t("cart")}</span>
			{count > 0 && (
				<span
					className="inline-flex h-5 min-w-5 items-center justify-center rounded-full px-1 text-xs font-bold"
					style={{
						background: "var(--primary)",
						color: "var(--primary-foreground)",
					}}
				>
					{count}
				</span>
			)}
		</Link>
	);
}
